import Registration from './pages/registration/Registration';
import Login from "./pages/login/Login";
import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import "./App.scss"
import CommonLayout from './views/CommonLayout'
import Courses from './pages/courses/Courses'
import Learning from './pages/learning/Learning'
import Journals from './pages/journals/Journals'
import Home from './pages/home/Home'
import Upgrades from './pages/upgrades/Upgrades';
import TaskList from './pages/Tasks/TaskList'
import Chat from './pages/chat/Chat';

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/register" element={<Registration />} />
          <Route path="/login" element={<Login />} />
          <Route path='/' element={<CommonLayout />}>
            <Route index element={<Home />} />
            <Route path='/courses' element={<Courses />} />
            <Route path='/learning' element={<Learning />} />
            <Route path='/journal' element={<Journals />} />
            <Route path='/upgrades' element={<Upgrades />} /> 
            <Route path='/tasks' element={<TaskList />} /> 
            <Route path='/chat' element={<Chat />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default App
